<script setup lang="ts">
const { isImpersonating, stopImpersonation, impersonatedUserName, impersonatedOrgName } = useImpersonation();
const isLoading = ref(false);

const handleStop = async () => {
  isLoading.value = true;
  try {
    await stopImpersonation();
  } finally {
    isLoading.value = false;
  }
};
</script>

<template>
  <div v-if="isImpersonating" class="w-full bg-warning-700 text-white px-4 py-2 flex items-center justify-between gap-4 text-sm font-medium z-50">
    <div class="flex items-center gap-2">
      <UIcon name="heroicons:eye" class="text-base shrink-0" />
      <span>
        {{ $t('admin.impersonation.banner', { user: impersonatedUserName, org: impersonatedOrgName }) }}
      </span>
    </div>
    <UButton size="xs" color="neutral" variant="subtle" :loading="isLoading" @click="handleStop">
      {{ $t('admin.impersonation.exit') }}
    </UButton>
  </div>
</template>
